import React from 'react'
import PropTypes from 'prop-types'
import './DetailedImmunization.css'

import newImmunization from '../../../../../../models/Immunization/Immunization'
import withPolyglot from '../../../../../common/withPolyglot'

// TODO Missing a Lot, professionalName
const DetailedImmunization = ({immunization, translate, adverseReaction}) => {
  return <div className='uk-align-center detailed-immunization'>
    <div className='detail'>{translate('administrationDate')}: <span>{immunization.getFormattedDate('pt-PT')}</span>
    </div>
    {/* <div className='detail'>Lote: <span>{immunization.lot}</span></div> */}
    {/* <div className='detail'>Administrado por: <span>{immunization.getPractitionerName()}</span></div> */}
    {/* <div className='detail'>Número de dose: <span>{immunization.doseSequence}</span></div> */}
    <ul data-uk-accordion>
      <li>
        <button className='uk-accordion-title' disabled={!immunization.observations}>
          {immunization.observations
            ? translate('observations')
            : translate('withoutObservations')
          }
        </button>
        <div className='uk-accordion-content'>{immunization.observations}</div>
      </li>
      <li>
        <button className='uk-accordion-title' disabled={!adverseReaction}>
          {adverseReaction
            ? translate('adverseReaction')
            : translate('withoutAdverseReaction')
          }
        </button>
        {adverseReaction
          ? <div className='uk-accordion-content adverse-reaction-details'>
            <div className='uk-clearfix'>{`${translate('description', true, 'immunizationInsertion')}`} <span className='uk-float-right'>{adverseReaction.description}</span></div>
            <hr />
            <div className='uk-clearfix'>{`${translate('start', true, 'immunizationInsertion')}`} <span className='uk-float-right'>{adverseReaction.startDate}</span></div>
            <hr />
            <div className='uk-clearfix'>{`${translate('end', true, 'immunizationInsertion')}`} <span className='uk-float-right'>{adverseReaction.endDate}</span></div>
            <hr />
            {adverseReaction.type && adverseReaction.type.length
              ? <div className='uk-clearfix'>{`${translate('reactionType', true, 'immunizationInsertion')}`} <span className='uk-float-right'>
                <ul>
                  {adverseReaction.type.map(type => <li key={type} className='uk-list'>{translate(type, true, 'immunizationInsertion')}</li>)}
                </ul>
              </span></div>
              : <div className='uk-clearfix'>{`${translate('reactionType', true, 'immunizationInsertion')}`} <span className='uk-float-right' /></div>
            }
            <hr />
            <div className='uk-clearfix'>{`${translate('description', true, 'immunizationInsertion')}`} <span className='uk-float-right'>{adverseReaction.descriptionOfType}</span></div>
            <hr />
            {adverseReaction.detailsOfReaction && adverseReaction.detailsOfReaction.length
              ? <div className='uk-clearfix'>{`${translate('reactionDetails', true, 'immunizationInsertion')}`} <span className='uk-float-right'>
                <ul>
                  {adverseReaction.detailsOfReaction.map(type => <li key={type} className='uk-list'>{translate(type, true, 'immunizationInsertion')}</li>)}
                </ul>
              </span></div>
              : <div className='uk-clearfix'>{`${translate('reactionDetails', true, 'immunizationInsertion')}`} <span className='uk-float-right' /></div>
            }
            <hr />
            <div className='uk-clearfix'>{`${translate('casualityRelation', true, 'immunizationInsertion')}`} <span className='uk-float-right'>{translate(adverseReaction.casualityRelation, true, 'immunizationInsertion')}</span></div>
          </div>
          : null
        }
      </li>
      <li>
        <button className='uk-accordion-title'>{translate('applicablePathologies')}</button>
        <div className='uk-accordion-content'>
          {immunization.protocolInfo.map(info => {
            return <div key={info.pathology.id}>{translate(info.pathology.displayKey, true, 'pathologies')}</div>
          })}
        </div>
      </li>
    </ul>
  </div>
}

DetailedImmunization.propTypes = {
  immunization: PropTypes.instanceOf(newImmunization).isRequired,
  adverseReaction: PropTypes.object
}

export default withPolyglot(DetailedImmunization, 'detailedImmunization')
